import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CreateAccount.scss';
import { postAccountCreation } from '../../APICalls/GetRequests';
import Cookies from 'js-cookie';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';


const CreateAccount = ({ setIsLoggedIn }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [authKey, setAuthKey] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const navigate = useNavigate();

  const isMinLength = password.length >= 8;
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const isPasswordValid = isMinLength && hasNumber && hasSpecialChar;

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.match(emailRegex)) {
      setErrorMessage('Please enter a valid email address.');
      return;
    }
    if (!isPasswordValid) {
      setErrorMessage('Password does not meet the required criteria.');
      return;
    }
    if (password !== passwordConfirm) {
      setErrorMessage('Passwords do not match.');
      return;
    }

    setErrorMessage('');
    setLoading(true);

    const body = { username, password, email, key: authKey };

    try {
      const data = await postAccountCreation(body);

      if (data.token) {
        Cookies.set('session_key', data.token, { expires: 7, secure: true });
        Cookies.set('user_id', data.user_id, { expires: 7, secure: true });
        Cookies.set('username', username, { expires: 7, secure: true });
        setIsLoggedIn(true);
        navigate('/');
      }
    } catch (error) {
      console.error('Account creation error:', error);
      setErrorMessage('Account creation failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="CreateAccount">
      <div className="create-account-box">
        <h2>Create Account</h2>


        <form className="create-account-form" onSubmit={handleFormSubmit}>
          <div className="form-group">
            <label className="create-account-label" htmlFor="authKey">Authentication Key</label>
            <input
              className="create-account-input"
              type="text"
              id="authKey"
              placeholder="Enter your Key"
              value={authKey}
              onChange={(e) => setAuthKey(e.target.value)}
              />
          </div>

          <div className="form-group">
            <label className="create-account-label" htmlFor="email">Email</label>
            <input
              className="create-account-input"
              type="email"
              id="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              />
          </div>

          <div className="form-group">
            <label className="create-account-label" htmlFor="username">Username</label>
            <input
              className="create-account-input"
              type="text"
              id="username"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              />
          </div>

          <div className="form-group password-group">
            <label className="create-account-label" htmlFor="password">Password</label>
            <div className="password-wrapper">
              <input
                className="create-account-input"
                type={showPassword ? 'text' : 'password'}
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
                >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </button>
            </div>

            <ul className="password-criteria">
              <li className={isMinLength ? 'valid' : 'invalid'}>
                {isMinLength ? <CheckCircleOutlineIcon className="icon" /> : <HighlightOffIcon className="icon" />}
                At least 8 characters
              </li>
              <li className={hasNumber ? 'valid' : 'invalid'}>
                {hasNumber ? <CheckCircleOutlineIcon className="icon" /> : <HighlightOffIcon className="icon" />}
                Contains a number
              </li>
              <li className={hasSpecialChar ? 'valid' : 'invalid'}>
                {hasSpecialChar ? <CheckCircleOutlineIcon className="icon" /> : <HighlightOffIcon className="icon" />}
                Contains a special character
              </li>
            </ul>
          </div>

          <div className="form-group password-group">
            <label className="create-account-label" htmlFor="passwordConfirm">Confirm Password</label>
            <div className="password-wrapper">
              <input
                className="create-account-input"
                type={showPasswordConfirm ? 'text' : 'password'}
                id="passwordConfirm"
                placeholder="Re-enter your password"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPasswordConfirm((prev) => !prev)}
                >
                {showPasswordConfirm ? <VisibilityOff /> : <Visibility />}
              </button>
            </div>
          </div>

          {errorMessage && <p className="error-message">{errorMessage}</p>}
          <div className="button-container">
            <button className="submit" type="submit" disabled={loading}>
              {loading ? <span className="spinner"></span> : 'Continue'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateAccount;
